(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('DisableController', DisableController);

    DisableController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function DisableController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.disableAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();
